import { useMerchantFeatures } from "@/hooks/use-merchant-features";

export const useIsHideExplorers = () => {
  const features = useMerchantFeatures();
  return features.includes("hideExplorers");
};
